import { render } from "./modal-options.vue?vue&type=template&id=665347ec"
import script from "./modal-options.vue?vue&type=script&lang=js"
export * from "./modal-options.vue?vue&type=script&lang=js"

import "./modal-options.vue?vue&type=style&index=0&id=665347ec&lang=css"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__